import { CircularProgress } from '@mui/material';
import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import styled from 'styled-components';
import UserLayout from '../components/UserLayout';
import { useTwilioUserMediaContext } from '../customer-call-sdk';

const StyledPermissions = styled(UserLayout)`
    body {
        background-color: #161616;
    }
    background-color: #161616;
`;

const PermissionBox = styled.div`
    width: 500px;
    height: 364px;
    background: rgb(29, 29, 29);
    border-radius: 10px;
    position: relative;
    padding: 2.5rem;
    display: flex;
    flex-direction: column;
    -webkit-box-align: center;
    align-items: center;

    top: 50%;
    left: 50%;
    transform: translate3d(-50%, -50%, 0);
`;

const PermissionHeader = styled.div`
    color: rgb(255, 255, 255);
    font-family: sans-serif;
    font-size: 32px;
    letter-spacing: 0px;
    text-align: center;
    margin-bottom: 2rem;
    font-weight: bold;
`;

const PermissionBody = styled.div`
    color: rgb(255, 255, 255);
    font-family: sans-serif;
    font-size: 20px;
    font-weight: normal;
    letter-spacing: 0px;
    text-align: center;
    margin-bottom: 2.5rem;
`;

const Permissions: React.FunctionComponent = () => {
    const {
        requestMediaPermission,
        audioDeviceId,
        videoDeviceId,
        isMediaPermissionGranted,
        isMediaPermissionDenied,
    } = useTwilioUserMediaContext();

    useEffect(() => {
        requestMediaPermission({
            audioDeviceId: audioDeviceId ?? '',
            videoDeviceId: videoDeviceId ?? '',
            type: 'ideal',
        });
    }, []);

    if (isMediaPermissionGranted || isMediaPermissionDenied) {
        return <Navigate to="/home" replace />;
    }

    return (
        <StyledPermissions>
            <PermissionBox>
                <PermissionHeader>🎛 Enabling camera &amp; mic</PermissionHeader>
                <PermissionBody>
                    When permission dialogs appear, select “Allow” to proceed.
                </PermissionBody>
                <CircularProgress size={24} className="text-white" />
            </PermissionBox>
        </StyledPermissions>
    );
};

export default Permissions;
